<template>
  <div v-if="! $isEmpty(persona)">
    <a-spin :spinning="loading">
      <a-form-model layout="vertical" :model="iPersona" :rules="formRules"
                    @submit="guardarDatosPersonales"
                    @submit.native.prevent ref="datosPersonalesForm"

      >
        <a-tabs :active-key="keyTab" @change="changeTab">
          <a-tab-pane key="0" force-render>
      <span slot="tab">
        <a-icon type="user"/>
        Información Personal
      </span>
            <a-card>
              <a-row :gutter="[16,16]">
                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('Nombre')" prop="name" has-feedback>
                    <a-input style="width: 100%"
                             class="ant-uppercase"
                             :readOnly="readOnly"
                             v-model="iPersona.name"
                             :disabled="disabled.name"
                    ></a-input>
                  </a-form-model-item>
                </a-col>
                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('Primer apellido')" prop="last_name1" has-feedback>
                    <a-input style="width: 100%"
                             class="ant-uppercase"
                             :readOnly="readOnly"
                             v-model="iPersona.last_name1"
                             :disabled="disabled.last_name1"
                    ></a-input>
                  </a-form-model-item>
                </a-col>
                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('Segundo apellido')" prop="last_name2" has-feedback>
                    <a-input style="width: 100%"
                             class="ant-uppercase"
                             :readOnly="readOnly"
                             v-model="iPersona.last_name2"
                             :disabled="disabled.last_name1"
                    ></a-input>
                  </a-form-model-item>
                </a-col>
                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('Identificación')" prop="id_person" has-feedback>
                    <a-input style="width: 100%"
                             class="ant-uppercase"
                             readOnly
                             v-model="iPersona.id_person"
                             :disabled="disabled.id_person"
                    ></a-input>
                  </a-form-model-item>
                </a-col>
                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('Tipo Doc.')" prop="type_id" has-feedback>
                    <form-model-dropdown style="width: 100%"
                                         v-model="iPersona.type_id"
                                         endpoint="hierarchy_lookup"
                                         :disabled="isDisabledTipoDoc"
                                         :params="request.tipo_documento"
                    ></form-model-dropdown>
                  </a-form-model-item>
                </a-col>
                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('Fecha expedición')" prop="date_expedition_cc" has-feedback>
                    <a-date-picker style="width: 100%"
                                   type="date"
                                   valueFormat="Y-MM-DD HH:mm:ss"
                                   :disabled="disabled.date_expedition_cc"
                                   v-model="iPersona.date_expedition_cc"/>
                  </a-form-model-item>
                </a-col>
                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('Pais de expedición')" prop="id_h_country_expedition" has-feedback>
                    <form-model-dropdown style="width: 100%"
                                         v-model="iPersona.id_h_country_expedition"
                                         :selectedObj.sync="dropdown.country_expedition_selected"
                                         endpoint="hierarchy_lookup"
                                         :customSlots="['suffixIcon']"
                                         :params="request.paises"
                                         :disabled="disabled.id_h_country_expedition"
                    >
                      <template slot="suffixIcon">
                        <img style="max-width: 20px"
                             :src="flags[dropdown.country_expedition_selected.equivalency]"
                             alt=""
                             v-if="dropdown.country_expedition_selected && dropdown.country_expedition_selected.equivalency">
                      </template>
                    </form-model-dropdown>
                  </a-form-model-item>
                </a-col>
                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('Ciudad expedición')" prop="id_h_city_expedition" has-feedback>
                    <form-model-lookup style="width: 100%"
                                       v-model="iPersona.id_h_city_expedition"
                                       endpoint="hierarchy_lookup"
                                       :params="request.city"
                                       :disabled="disabled.id_h_city_expedition"
                    ></form-model-lookup>
                  </a-form-model-item>
                </a-col>
                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('Email personal')" prop="personal_mail" has-feedback>
                    <a-input style="width: 100%"
                             v-model="iPersona.personal_mail"
                             :disabled="disabled.date_expedition_cc"
                    ></a-input>
                  </a-form-model-item>
                </a-col>
                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('Email Corporativo')" prop="mail" has-feedback>
                    <a-input style="width: 100%"
                             v-model="iPersona.mail"
                             :disabled="disabled.mail"
                    ></a-input>
                  </a-form-model-item>
                </a-col>
                <a-col v-bind="colSpan" v-if="mostrarPasaporte">
                  <a-form-model-item :label="$t('No. Pasaporte')" prop="id_passport" has-feedback>
                    <a-input class="ant-uppercase" style="width: 100%"
                             v-model="iPersona.id_passport"
                             :disabled="disabled.id_passport"
                    ></a-input>
                  </a-form-model-item>
                </a-col>
              </a-row>
              <a-row :gutter="[16,16]">
                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('Cabeza de familia')" prop="head_family" :has-feedback="false">
                    <form-model-checkbox
                      v-model="iPersona.head_family"
                      :disabled="disabled.head_family"
                    >
                    </form-model-checkbox>
                  </a-form-model-item>
                </a-col>
                <a-col v-bind="colSpan">
                  <a-form-model-item v-if="iPersona.head_family" :label="$t('Personas a cargo')" prop="person_in_charge"
                                     has-feedback>
                    <a-input-number class="ant-uppercase" style="width: 100%"
                                    v-model="iPersona.person_in_charge"
                                    :disabled="disabled.person_in_charge"
                    ></a-input-number>
                  </a-form-model-item>
                </a-col>
              </a-row>
              <a-row :gutter="[16,16]">
                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('Consume medicamento')" prop="consume_medication"
                                     :has-feedback="false">
                    <form-model-checkbox
                      v-model="iPersona.consume_medication"
                      :disabled="disabled.consume_medication"
                    >
                    </form-model-checkbox>
                  </a-form-model-item>
                </a-col>
                <a-col v-bind="colSpan">
                  <a-form-model-item v-if="iPersona.consume_medication" :label="$t('Cuál medicamento')"
                                     prop="medication" has-feedback>
                    <a-input class="ant-uppercase" style="width: 100%"
                             v-model="iPersona.medication"
                             :disabled="disabled.medication"
                    ></a-input>
                  </a-form-model-item>
                </a-col>
                <template v-if="idFinanciera">
                  <a-col v-bind="colSpan">
                    <a-form-model-item :label="$t('Identificación financiera')" prop="identificacion_financiera"
                                       has-feedback>
                      <a-input style="width: 100%"
                               class="ant-uppercase"
                               v-model="iPersona.identificacion_financiera"
                               :disabled="disabled.identificacion_financiera"
                      ></a-input>
                    </a-form-model-item>
                  </a-col>
                </template>
              </a-row>
              <a-row :gutter="[16,16]">
                <a-col v-bind="colSpan" v-if="mostrarAnteojos">
                  <a-form-model-item :label="$t('Usa anteojos')" prop="id_h_glasses"
                                     :has-feedback="false">
                    <form-model-checkbox
                      v-model="iPersona.id_h_glasses"
                      :disabled="disabled.id_h_glasses"
                    >
                    </form-model-checkbox>
                  </a-form-model-item>
                </a-col>
                <a-col v-bind="colSpan">
                  <a-form-model-item v-if="iPersona.id_h_glasses" :label="$t('Motivo de uso')"
                                     prop="glasses_obs" has-feedback>
                    <a-input class="ant-uppercase" style="width: 100%"
                             v-model="iPersona.glasses_obs"
                             :disabled="disabled.glasses_obs"
                    ></a-input>
                  </a-form-model-item>
                </a-col>
              </a-row>
            </a-card>
          </a-tab-pane>
          <a-tab-pane key="1" force-render>
      <span slot="tab">
        <a-icon type="calendar"/>
              Nacimiento
      </span>
            <a-card>
              <a-row :gutter="[16,16]">
                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('Pais de nacimiento')" prop="id_h_country_birth" has-feedback>
                    <form-model-dropdown style="width: 100%"
                                         v-model="iPersona.id_h_country_birth"
                                         :selectedObj.sync="dropdown.country_birth_selected"
                                         endpoint="hierarchy_lookup"
                                         :customSlots="['suffixIcon']"
                                         :params="request.paises"
                                         :disabled="disabled.id_h_country_birth"
                    >
                      <template slot="suffixIcon">
                        <img style="max-width: 20px"
                             :src="flags[dropdown.country_birth_selected.equivalency]"
                             alt=""
                             v-if="dropdown.country_birth_selected && dropdown.country_birth_selected.equivalency">
                      </template>
                    </form-model-dropdown>
                  </a-form-model-item>
                </a-col>
                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('Ciudad de nacimiento')" prop="id_h_city_birth" has-feedback>
                    <form-model-lookup style="width: 100%"
                                       v-model="iPersona.id_h_city_birth"
                                       endpoint="hierarchy_lookup"
                                       :params="request.city"
                                       :disabled="disabled.id_h_city_birth"
                    ></form-model-lookup>
                  </a-form-model-item>
                </a-col>
                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('Género')" prop="id_h_gender" has-feedback>
                    <form-model-dropdown style="width: 100%"
                                         v-model="iPersona.id_h_gender"
                                         endpoint="hierarchy_lookup"
                                         :params="request.genero"
                                         :disabled="disabled.id_h_gender"
                    ></form-model-dropdown>
                  </a-form-model-item>
                </a-col>
                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('Estado civil')" prop="id_h_marital_status" has-feedback>
                    <form-model-dropdown style="width: 100%"
                                         v-model="iPersona.id_h_marital_status"
                                         endpoint="hierarchy_lookup"
                                         :params="request.estado_civil"
                                         :disabled="disabled.id_h_marital_status"
                    ></form-model-dropdown>
                  </a-form-model-item>
                </a-col>
                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('Grupo sanguíneo')" prop="id_h_blood_group" has-feedback>
                    <form-model-dropdown style="width: 100%"
                                         v-model="iPersona.id_h_blood_group"
                                         endpoint="hierarchy_lookup"
                                         :params="request.grupo_sanguineo"
                                         :disabled="disabled.id_h_blood_group"
                    ></form-model-dropdown>
                  </a-form-model-item>
                </a-col>
                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('Factor RH')" prop="id_h_blood_rh" has-feedback>
                    <form-model-dropdown style="width: 100%"
                                         v-model="iPersona.id_h_blood_rh"
                                         endpoint="hierarchy_lookup"
                                         :params="request.factor_rh"
                                         :disabled="disabled.id_h_blood_rh"
                    ></form-model-dropdown>
                  </a-form-model-item>
                </a-col>
                <a-col v-bind="colSpan" v-if="mostrarLovEtnia">
                  <a-form-model-item :label="$t('Etnia')" prop="id_h_etnia" has-feedback>
                    <form-model-dropdown style="width: 100%"
                                         v-model="iPersona.id_h_etnia"
                                         endpoint="hierarchy_lookup"
                                         :params="request.etnia"
                                         :disabled="disabled.id_h_etnia"
                    ></form-model-dropdown>
                  </a-form-model-item>
                </a-col>
                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('Fecha nacimiento')" prop="date_birth" has-feedback>
                    <a-date-picker style="width: 100%"
                                   type="date"
                                   valueFormat="Y-MM-DD HH:mm:ss"
                                   v-model="iPersona.date_birth"
                                   :disabled="disabled.date_birth"
                    />
                  </a-form-model-item>
                </a-col>
                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('Edad')" prop="edad" has-feedback>
                    <a-tag color="blue" style="height: 32px;
    padding-top: 4px;
    width: 100%;">
                      <a-icon type="gift"/>
                      {{iPersona.edad}}
                    </a-tag>
                  </a-form-model-item>
                </a-col>
              </a-row>
            </a-card>
          </a-tab-pane>
          <a-tab-pane key="2" force-render>
          <span slot="tab">
            <a-icon type="home"/>
              Ubicación
          </span>
            <a-card>
              <a-row :gutter="[16,16]">
                <a-form-model-item v-bind="colSpan" :label="$t('Dirección')" prop="address">
                  <a-textarea placeholder="Dirección"
                              readOnly
                              autoSize
                              v-model="iPersona.address"
                              :disabled="disabled.address"
                              v-on:click="modalDireccionVisible = true">
                  </a-textarea>
                </a-form-model-item>
                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('Ciudad Residencia')" prop="id_h_residence_city" has-feedback>
                    <form-model-lookup style="width: 100%"
                                       v-model="iPersona.id_h_residence_city"
                                       endpoint="hierarchy_lookup"
                                       :params="request.city"
                                       :selectedObj.sync="ciudad_residencia"
                                       :disabled="disabled.id_h_residence_city"
                    ></form-model-lookup>
                  </a-form-model-item>
                </a-col>
                <a-col v-bind="colSpan" v-if="mostrarLovLocalidad && isResidenciaBogota">
                  <a-form-model-item :label="$t('Localidad')" prop="zone" has-feedback>
                    <form-model-dropdown style="width: 100%"
                                         v-model="iPersona.zone"
                                         endpoint="hierarchy_lookup"
                                         :params="request.localidad"
                                         :disabled="disabled.zone"
                    ></form-model-dropdown>
                  </a-form-model-item>
                </a-col>
                <a-col v-bind="colSpan" v-if="mostrarLovLocalidad">
                  <a-form-model-item :label="$t('Zona')" prop="zone" has-feedback>
                    <form-model-dropdown style="width: 100%"
                                         v-model="iPersona.corporate_card"
                                         endpoint="hierarchy_lookup"
                                         :params="request.zona"
                                         :disabled="disabled.zone"
                    ></form-model-dropdown>
                  </a-form-model-item>
                </a-col>
                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('Tipo de vivienda')" prop="id_h_residence_type" has-feedback>
                    <form-model-dropdown style="width: 100%"
                                         v-model="iPersona.id_h_residence_type"
                                         endpoint="hierarchy_lookup"
                                         :params="request.tipo_residencia"
                                         :disabled="disabled.id_h_residence_type"
                    ></form-model-dropdown>
                  </a-form-model-item>
                </a-col>
                <a-col v-bind="colSpan" v-if="mostrarLovEstrato">
                  <a-form-model-item :label="$t('Estrato')" prop="id_h_stratum" has-feedback>
                    <form-model-dropdown style="width: 100%"
                                         v-model="iPersona.id_h_stratum"
                                         endpoint="hierarchy_lookup"
                                         :params="request.estrato"
                                         :disabled="disabled.id_h_stratum"
                    ></form-model-dropdown>
                  </a-form-model-item>
                </a-col>
                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('Barrio')" prop="residence_place" has-feedback>
                    <a-input class="ant-uppercase" style="width: 100%"
                             v-model="iPersona.residence_place"
                             :disabled="disabled.residence_place"
                    ></a-input>
                  </a-form-model-item>
                </a-col>
                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('Celular')" prop="cell_phone1" has-feedback>
                    <a-input-number v-if="$getConfigValue('BIODATA_CELULAR_TELEFONO_CONVERTIR_NUMERICO', 'NO') === 'SI'"
                                    style="width: 100%"
                                    v-model="iPersona.cell_phone1"
                                    :disabled="disabled.cell_phone1"
                    />
                    <a-input v-else
                             class="ant-uppercase"
                             style="width: 100%" v-model="iPersona.cell_phone1"
                             :disabled="disabled.cell_phone1"
                    ></a-input>

                  </a-form-model-item>
                </a-col>
                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('Teléfono casa')" prop="phone_home" has-feedback>
                    <a-input-number v-if="$getConfigValue('BIODATA_CELULAR_TELEFONO_CONVERTIR_NUMERICO', 'NO') === 'SI'"
                                    style="width: 100%" v-model="iPersona.phone_home"
                                    :disabled="disabled.phone_home"
                    />
                    <a-input
                      v-else
                      class="ant-uppercase"
                      style="width: 100%"
                      v-model="iPersona.phone_home"
                      :disabled="disabled.phone_home"
                    ></a-input>
                  </a-form-model-item>
                </a-col>
                <a-col v-bind="colSpan" v-if="mostrarLovZona">
                  <a-form-model-item :label="$t('Zona')" prop="zone" has-feedback>
                    <form-model-dropdown style="width: 100%"
                                         v-model="iPersona.zone"
                                         endpoint="hierarchy_lookup"
                                         :params="request.zona"
                                         :disabled="disabled.zone"
                    ></form-model-dropdown>
                  </a-form-model-item>
                </a-col>
                <a-col v-bind="colSpan" v-if="mostrarLovTipoVivienda">
                  <a-form-model-item :label="$t('Tipo De Vivienda')" prop="recruitment_source" has-feedback>
                    <form-model-dropdown style="width: 100%"
                                         v-model="iPersona.recruitment_source"
                                         endpoint="hierarchy_lookup"
                                         :params="request.tipo_vivienda"
                                         :disabled="disabled.recruitment_source"
                    ></form-model-dropdown>
                  </a-form-model-item>
                </a-col>
                <a-col v-if="ocultar_aspiracion_reclutamiento" v-bind="colSpan">
                  <a-form-model-item :label="$t('Aspiración')" prop="aspiration" has-feedback>
                    <a-input-number
                      style="width: 100%"
                      :min="1"
                      :max="6"
                      v-if="aspiracion_sevicol"
                      v-model="iPersona.aspiration"
                      :disabled="disabled.aspiration"
                    >
                    </a-input-number>
                    <a-input-number v-else style="width: 100%;" v-model="iPersona.aspiration" :disabled="disabled.aspiration"
                                    :formatter="value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                                    :parser="value => value.replace(/\$\s?|(,*)/g, '')">
                    </a-input-number>
                  </a-form-model-item>
                </a-col>
                <a-col v-if="ocultar_aspiracion_reclutamiento" v-bind="colSpan">
                  <a-form-model-item v-if="aspiracion_sevicol" :label="$t('Fuente Reclutamiento')"
                                     prop="recruitment_source" has-feedback>
                    <form-model-dropdown style="width: 100%"
                                         v-model="iPersona.recruitment_source"
                                         endpoint="hierarchy_lookup"
                                         :params="request.tipo_vivienda"
                                         :disabled="disabled.recruitment_source"
                    ></form-model-dropdown>
                  </a-form-model-item>

                  <a-form-model-item v-else :label="$t('Fuente Reclutamiento')" prop="recruitment_source" has-feedback>
                    <form-model-dropdown style="width: 100%"
                                         v-model="iPersona.recruitment_source"
                                         endpoint="hierarchy_lookup"
                                         :selectedObj.sync="selectedFuente"
                                         :params="request.fuente_reclutamiento"
                                         :disabled="disabled.recruitment_source"
                    ></form-model-dropdown>
                  </a-form-model-item>
                </a-col>
                <template v-if="selectedFuente && selectedFuente.text==='REFERIDO'">
                  <a-col v-bind="colSpan">
                    <a-form-model-item :label="$t('Id Referido')" prop="referred_idperson" has-feedback>
                      <form-model-lookup style="width: 100%"
                                         v-model="iPersona.referred_idperson"
                                         endpoint="personas"
                                         :disabled="disabled.recruitment_source"
                      ></form-model-lookup>
                    </a-form-model-item>
                  </a-col>
                </template>
              </a-row>
            </a-card>
          </a-tab-pane>
          <a-tab-pane key="3" force-render>
          <span slot="tab">
            <a-icon type="user"/>
            Otros Datos Personales
          </span>
            <biodata-otros-datos-personales v-if="persona" :persona="persona"/>
          </a-tab-pane>
        </a-tabs>

        <direccion-estructurada v-model="iPersona.address" :visible="modalDireccionVisible"
                                :direccionActual="iPersona.address"
                                @cancel="modalDireccionVisible = false"
                                @success="direccionCambiada"></direccion-estructurada>
        <template v-if="keyTab!=='3'">
          <a-affix :offset-bottom="10">
            <a-card style="text-align: right" :bodyStyle="{padding: '12px 24px'}">
              <a-button v-if="!$userIsInrol('Query')"
                type="primary"
                html-type="submit">
                Guardar Cambios
              </a-button>
            </a-card>
          </a-affix>
        </template>
      </a-form-model>
    </a-spin>
  </div>
</template>
<script>
  import JsUtils from '@/util/JsUtils'
  import HttpUtil from '@/util/HttpUtil'
  import DateUtils from '@/util/DateUtils'
  import FLAGS from 'CustomModules/GlobalBPOCore/Util/FlagsUtil'
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'

  const dateFields = [
    'date_expedition_cc',
    'date_birth'
  ]

  const fieldsTabOne = [
    'name',
    'last_name1',
    'last_name2',
    'id_person',
    'tipo_documento',
    'date_expedition_cc',
    'id_h_country_expedition',
    'id_h_city_expedition',
    'personal_mail',
    'mail',
    'identificacion_financiera',
    'consume_medication',
    'medication',
    'head_family',
    'person_in_charge'
  ]

  const fieldsTabTwo = [
    'id_h_country_birth',
    'id_h_city_birth',
    'id_h_gender',
    'id_h_marital_status',
    'id_h_blood_group',
    'id_h_blood_rh',
    'date_birth'
  ]

  const fieldsTabThree = [
    'address',
    'id_h_residence_city',
    'residence_place',
    'cell_phone1',
    'phone_home',
    'zone',
    'aspiration',
    'recruitment_source',
    'referred_idperson'
  ]

  const fieldsTab = [
    fieldsTabOne,
    fieldsTabTwo,
    fieldsTabThree
  ]

  function searchFields (field) {
    for (let i = 0; i < fieldsTab.length; i++) {
      if (fieldsTab[i].includes(field)) {
        return i
      }
    }
  }

  export default {
    props: ['persona'],
    mounted () {
      this.httpClient = new HttpUtil()
      this.loadData()
      this.initFormRules()
      const fields = [
        ...fieldsTabOne,
        ...fieldsTabTwo,
        ...fieldsTabThree,
        ...dateFields
      ]
      for (let field of fields) {
        this.disabled[field] = this.$getConfigValue('BIODATA_' + field.toUpperCase() + '_DISABLED', 'NO') === 'SI'
      }
    },
    data () {
      return {
        disabled: {},
        keyTab: '0',
        valueKey: {},
        ciudad_residencia: {},
        isResidenciaBogota: false,
        selectedFuente: {},
        isDisabledTipoDoc: !this.$userIsInrol('Management'),
        idFinanciera: this.$getConfigValue('VISIBLE_IDFINANCIERA', 'NO') === 'SI',
        readOnly: this.$getConfigValue('BIODATA_SOLO_LECTURA_NOMBRE_COMPLETO', 'NO') === 'SI',
        mostrarLovZona: this.$getConfigValue('MOSTRAR_LOV_ZONA_BIODATA_INFORMACION_PERSONAL', 'SI') === 'SI',
        mostrarLovLocalidad: this.$getConfigValue('MOSTRAR_LOCALIDAD_MASIVO', 'NO') === 'SI',
        ocultar_aspiracion_reclutamiento: this.$getConfigValue('OCULTAR_ASPIRACION_RECLUTAMIENTO_BIODATA', 'SI') === 'NO',
        mostrarLovTipoVivienda: this.$getConfigValue('MOSTRAR_TIPO_VIVIENDA_EMA', 'NO') === 'SI',
        mostrarPasaporte: this.$getConfigValue('MOSTRAR_PASAPORTE', 'NO') === 'SI',
        mostrarLovEtnia: this.$getConfigValue('MOSTRAR_ETNIA', 'NO') === 'SI',
        mostrarLovEstrato: this.$getConfigValue('MOSTRAR_ESTRATO', 'NO') === 'SI',
        mostrarAnteojos: this.$getConfigValue('MOSTRAR_ANTEOJOS', 'NO') === 'SI',
        modalDireccionVisible: false,
        loading: false,
        colSpan: {
          xs: 24,
          md: 8
        },
        colSpanCheck: {
          xs: 24,
          md: 12
        },
        iPersona: {},
        formRules: {},
        fiChkOptions: {
          'wrapper-col': {
            offset: 8,
            span: 16
          }
        },
        request: {
          paises: {
            h_lookup_type: 'PAISES_HV'
          },
          tipo_documento: {
            h_lookup_type: 'TIPO_DOCUMENTO',
            use_code: true
          },
          grupo_sanguineo: {
            h_lookup_type: 'GRUPO_SANGUINEO'
          },
          genero: {
            h_lookup_type: 'SEXO'
          },
          factor_rh: {
            h_lookup_type: 'RH'
          },
          estado_civil: {
            h_lookup_type: 'ESTADO_CIVIL'
          },
          fuente_reclutamiento: {
            h_lookup_type: 'FUENTE_RECLUTAMIENTO'
          },
          tipo_vivienda: {
            h_lookup_type: 'TIPO_VIVIENDA'
          },
          city: {
            h_lookup_type: 'CIUDADES_HV'
          },
          zona: {
            h_lookup_type: 'ZONA'
          },
          localidad: {
            h_lookup_type: 'LOCALIDADES_BOGOTA'
          },
          etnia: {
            h_lookup_type: 'ETNIA'
          },
          tipo_residencia: {
            h_lookup_type: 'TIPO_RESIDENCIA'
          },
          estrato: {
            h_lookup_type: 'ESTRATO'
          }
        },
        dropdown: {
          country_expedition_selected: {},
          country_birth_selected: {}
        },
        flags: FLAGS,
        aspiracion_sevicol: this.$getConfigValue('BIODATA_INFORMACION_ACADEMICA_LABEL_DINAMICA', 'NO') === 'SI'
      }
    },
    methods: {
      changeTab (e) {
        this.keyTab = e
      },
      direccionCambiada () {
        this.modalDireccionVisible = false
      },
      loadData () {
        if (JsUtils.isEmpty(this.persona)) {
          return
        }
        this.loading = true
        this.httpClient.getInstance().get('biodata/consultarDatosPersonales/' + this.persona)
          .then(response => {
            let newData = {...response.data}
            newData.date_expedition_cc = response.data.date_expedition_cc && moment(response.data.date_expedition_cc)
            newData.date_birth = response.data.date_birth && moment(response.data.date_birth)
            this.iPersona = newData
            this.loading = false
          })
          .catch(() => {
            Mensajes.error('Error', 'No fue posible consultar los datos personales, contacte al administrador.')
          })
          .then(() => {
            this.loading = false
          })
      },
      guardarDatosPersonales () {
        if (this.loading) return
        this.$refs.datosPersonalesForm.validate((valid, fields) => {
          Object.keys(fields).forEach(field => {
            this.keyTab = searchFields(field) + ''
            return 0
          }
          )
          if (valid) {
            this.loading = true
            let request = this.prepareDates({...this.iPersona})

            this.httpClient.getInstance().post('biodata/guardardatospersonales', request)
              .then(() => {
                Mensajes.success('Correcto', 'Datos guardados correctamente')
              })
              .catch((error) => {
                Mensajes.error('Error', this.$getErrorMessage(error, 'No fue posible guardar la información, contacte al administrador.'))
              })
              .then(() => {
                this.loading = false
              })
          } else {
            Mensajes.error('Error', 'Faltan campos requeridos por diligenciar correctamente.')
          }
        })
      },
      initFormRules () {
        this.formRules = {
          name: [{
            required: this.$getConfigValue('BIODATA_REQUERIDO_NAME', false) === 'SI',
            message: 'Valor requerido'
          }],
          last_name1: [{
            required: this.$getConfigValue('BIODATA_REQUERIDO_LAST_NAME1', false) === 'SI',
            message: 'Valor requerido'
          }],
          last_name2: [{
            required: this.$getConfigValue('BIODATA_REQUERIDO_LAST_NAME2', false) === 'SI',
            message: 'Valor requerido'
          }],
          id_person: [{
            required: this.$getConfigValue('BIODATA_REQUERIDO_ID_PERSON', false) === 'SI',
            message: 'Valor requerido'
          }],
          type_id: [{
            required: this.$getConfigValue('BIODATA_REQUERIDO_TYPE_ID', false) === 'SI',
            message: 'Valor requerido'
          }],
          id_h_country_expedition: [{
            required: this.$getConfigValue('BIODATA_REQUERIDO_ID_H_COUNTRY_EXPEDITION', false) === 'SI',
            message: 'Valor requerido'
          }],
          date_expedition_cc: [{
            required: this.$getConfigValue('BIODATA_REQUERIDO_DATE_EXPEDITION_CC', false) === 'SI',
            message: 'Valor requerido'
          }],
          id_h_city_expedition: [{
            required: this.$getConfigValue('BIODATA_REQUERIDO_ID_H_CITY_EXPEDITION', false) === 'SI',
            message: 'Valor requerido'
          }],
          identificacion_financiera: [{
            required: this.$getConfigValue('BIODATA_REQUERIDO_IDENTIFICACION_FINANCIERA', false) === 'SI',
            message: 'Valor requerido'
          }],
          id_h_country_birth: [{
            required: this.$getConfigValue('BIODATA_REQUERIDO_ID_H_COUNTRY_BIRTH', false) === 'SI',
            message: 'Valor requerido'
          }],
          id_h_blood_group: [{
            required: this.$getConfigValue('BIODATA_REQUERIDO_ID_H_BLOOD_GROUP', false) === 'SI',
            message: 'Valor requerido'
          }],
          date_birth: [{
            required: this.$getConfigValue('BIODATA_REQUERIDO_DATE_BIRTH', false) === 'SI',
            message: 'Valor requerido'
          }],
          id_h_city_birth: [{
            required: this.$getConfigValue('BIODATA_REQUERIDO_ID_H_CITY_BIRTH', false) === 'SI',
            message: 'Valor requerido'
          }],
          id_h_gender: [{
            required: this.$getConfigValue('BIODATA_REQUERIDO_ID_H_GENDER', false) === 'SI',
            message: 'Valor requerido'
          }],
          edad: [{
            required: this.$getConfigValue('BIODATA_REQUERIDO_EDAD', false) === 'SI',
            message: 'Valor requerido'
          }],
          id_h_blood_rh: [{
            required: this.$getConfigValue('BIODATA_REQUERIDO_ID_H_BLOOD_RH', false) === 'SI',
            message: 'Valor requerido'
          }],
          id_h_marital_status: [{
            required: this.$getConfigValue('BIODATA_REQUERIDO_ID_H_MARITAL_STATUS', false) === 'SI',
            message: 'Valor requerido'
          }],
          address: [{
            required: this.$getConfigValue('BIODATA_REQUERIDO_ADDRESS', false) === 'SI',
            message: 'Valor requerido'
          }],
          mail: [{
            required: this.$getConfigValue('BIODATA_REQUERIDO_MAIL', false) === 'SI',
            message: 'Valor requerido'
          },
            {type: 'email', message: 'Debe ser un correo válido.', trigger: 'blur'}
          ],
          consume_medication: [{
            required: this.$getConfigValue('BIODATA_REQUERIDO_CONSUME_MEDICATION', false) === 'SI',
            message: 'Valor requerido'
          }],
          id_h_residence_city: [{
            required: this.$getConfigValue('BIODATA_REQUERIDO_ID_H_RESIDENCE_CITY', false) === 'SI',
            message: 'Valor requerido'
          }],
          recruitment_source: [{
            required: this.$getConfigValue('BIODATA_REQUERIDO_RECRUITMENT_SOURCE', false) === 'SI',
            message: 'Valor requerido'
          }],
          referred_idperson: [{
            required: this.$getConfigValue('BIODATA_REQUERIDO_REFERRED_IDPERSON', false) === 'SI',
            message: 'Valor requerido'
          }],
          zone: [{
            required: this.$getConfigValue('BIODATA_REQUERIDO_ZONE', false) === 'SI',
            message: 'Valor requerido'
          }],
          residence_place: [{
            required: this.$getConfigValue('BIODATA_REQUERIDO_RESIDENCE_PLACE', false) === 'SI',
            message: 'Valor requerido'
          }],
          aspiration: [{
            required: this.$getConfigValue('BIODATA_REQUERIDO_ASPIRATION', false) === 'SI',
            message: 'Valor requerido'
          }],
          phone_home: [{
            required: this.$getConfigValue('BIODATA_REQUERIDO_PHONE_HOME', false) === 'SI',
            message: 'Valor requerido'
          }],
          head_family: [{
            required: this.$getConfigValue('BIODATA_REQUERIDO_HEAD_FAMILY', false) === 'SI',
            message: 'Valor requerido'
          }],
          person_in_charge: [{
            required: this.$getConfigValue('BIODATA_REQUERIDO_PERSON_IN_CHARGE', false) === 'SI',
            message: 'Valor requerido'
          }],
          cell_phone1: [{
            required: this.$getConfigValue('BIODATA_REQUERIDO_CELL_PHONE1', false) === 'SI',
            message: 'Valor requerido'
          }],
          personal_mail: [{
            required: this.$getConfigValue('BIODATA_REQUERIDO_PERSONAL_MAIL', false) === 'SI',
            message: 'Valor requerido'
          },
            {type: 'email', message: 'Debe ser un correo válido.', trigger: 'blur'}
          ]

        }
      },
      prepareDates (request) {
        dateFields.map(d => {
          request[d] = DateUtils.forBackEnd(request[d])
        })
        return request
      }
    },
    watch: {
      persona () {
        this.loadData()
      },
      ciudad_residencia () {
        if (this.ciudad_residencia) {
          if (this.ciudad_residencia.value === '26259') { // SE COMPARA CONTRA EL ID_H_LOOKUP DE BOGOTA DEBIDO A QUE NO USA EL CODE
            this.isResidenciaBogota = true
          } else {
            this.isResidenciaBogota = false
          }
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Biodata/BiodataDatosPersonales.vue